// Toggle.jsx
// Client: vmfive
// Version: 1.0.0

import './Toggle.css';

export default function Toggle({ checked = false, onChange, className = '' }) {
  return (
    <label className={`toggle ${className}`} onClick={(e) => e.stopPropagation()}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="toggle__track">
        <span className="toggle__thumb" />
      </span>
    </label>
  );
}
